module.exports = __webpack_public_path__ + "img/profile.860b37ca.jpg";